// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.f5e578669.chunk.js";
	if (chunkId === 12) return "static/js/profiler.f5e578669.chunk.js";
	if (chunkId === 658) return "static/js/658.f5e578669.chunk.js";
	if (chunkId === 621) return "static/js/621.f5e578669.chunk.js";
	if (chunkId === 505) return "static/js/505.f5e578669.chunk.js";
	if (chunkId === 676) return "static/js/676.f5e578669.chunk.js";
	if (chunkId === 978) return "static/js/978.f5e578669.chunk.js";
	if (chunkId === 103) return "static/js/103.f5e578669.chunk.js";
	if (chunkId === 177) return "static/js/177.f5e578669.chunk.js";
	if (chunkId === 292) return "static/js/292.f5e578669.chunk.js";
	if (chunkId === 570) return "static/js/570.f5e578669.chunk.js";
	if (chunkId === 547) return "static/js/547.f5e578669.chunk.js";
	// return url for filenames based on template
	return undefined;
};